module.exports = __webpack_public_path__ + "static/media/pos_original.73bcb08d.svg";